import { create } from "zustand"

export interface SecureSharePrefill {
  email?: string
  name?: string
  /** Öffnet den Dialog direkt im gewünschten Modus (Standard: "send"). */
  mode?: "send" | "invite"
}

/**
 * Globaler Store für den Secure-Share-Dialog (Ctrl-Cmd-S).
 * Ermöglicht das Öffnen des Dialogs von überall im ERP — optional mit
 * vorbefüllter Empfängeradresse (z.B. aus der Kontakt-Schnellsuche).
 */
interface SecureShareState {
  open: boolean
  prefill: SecureSharePrefill | null
  openDialog: () => void
  openWith: (prefill: SecureSharePrefill) => void
  closeDialog: () => void
  setOpen: (open: boolean) => void
}

export const useSecureShareStore = create<SecureShareState>((set) => ({
  open: false,
  prefill: null,
  openDialog: () => set({ open: true, prefill: null }),
  openWith: (prefill) => set({ open: true, prefill }),
  closeDialog: () => set({ open: false }),
  setOpen: (open) => set({ open }),
}))
